<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          editBtnText: '回复', // 新增按钮文案
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '咨询内容',
              overHidden: true,
              prop: 'content',
              span: 24,
              align: 'left',
              editDisplay: false,
              rules: [{
                type: 'string', required: true, message: '场所名称不能为空', trigger: 'blur'
              }]
            },
            {
              label: '用户名',
              prop: 'user-username',
              span: 24,
              editDisplay: false
            },
            {
              label: '工号',
              prop: 'user_id',
              span: 24,
              editDisplay: false
            },
            {
              label: '部门',
              prop: 'user-class',
              span: 24,
              editDisplay: false
            },
            {
              label: '咨询图片',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              display: true,
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '回复内容',
              prop: 'reply',
              span: 24,
              type: 'textarea'
            },
            {
              label: '回复时间',
              prop: 'reply_time',
              editDisplay: false,
              span: 24,
            }
          ]
        }
      }
    }
  }
</script>
